import component from "./Badges";

export default component;
